import { render, staticRenderFns } from "./LfProgressBarComponent.vue?vue&type=template&id=6b6b846a&scoped=true"
import script from "./LfProgressBarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LfProgressBarComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LfProgressBarComponent.vue?vue&type=style&index=0&id=6b6b846a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b846a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6b846a')) {
      api.createRecord('6b6b846a', component.options)
    } else {
      api.reload('6b6b846a', component.options)
    }
    module.hot.accept("./LfProgressBarComponent.vue?vue&type=template&id=6b6b846a&scoped=true", function () {
      api.rerender('6b6b846a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProgressBar/LfProgressBarComponent.vue"
export default component.exports